import { render, staticRenderFns } from "./mt5-account-binding-process.html.vue?vue&type=template&id=123a6d73"
import script from "./mt5-account-binding-process.html.vue?vue&type=script&lang=js"
export * from "./mt5-account-binding-process.html.vue?vue&type=script&lang=js"
import style0 from "./mt5-account-binding-process.html.vue?vue&type=style&index=0&id=123a6d73&prod&lang=scss"
import style1 from "./mt5-account-binding-process.html.vue?vue&type=style&index=1&id=123a6d73&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports